export function isPdfFile(file: File): boolean {
  return file.type === "application/pdf" || file.name?.toLowerCase().endsWith(".pdf");
}
